import api from 'service/api'

const dponetAPI = api.create('dponet')

const get = async ({ committeeId = '', committeeUserId = '', ...params }) => {
  return await dponetAPI.get(
    `/committees/${committeeId}/committee_users/${committeeUserId}`,
    {
      params,
    },
  )
}

const create = async ({ committeeId = '', ...data }) => {
  return await dponetAPI.post(
    `/committees/${committeeId}/committee_users`,
    data,
  )
}

const changeRole = async ({
  committeeId = '',
  committeeUserId = '',
  ...data
}) => {
  return await dponetAPI.put(
    `/committees/${committeeId}/committee_users/${committeeUserId}/change_role`,
    data,
  )
}

const changeStatus = async ({ committeeId = '', committeeUserId = '' }) => {
  return await dponetAPI.put(
    `/committees/${committeeId}/committee_users/${committeeUserId}/change_status`,
  )
}

const destroy = async ({ committeeId = '', committeeUserId = '' }) => {
  return await dponetAPI.delete(
    `/committees/${committeeId}/committee_users/${committeeUserId}`,
  )
}

export default {
  get,
  create,
  changeRole,
  changeStatus,
  destroy,
}
